import React from "react";
import { useMutation } from "react-apollo";
import EasyEdit from "react-easy-edit";
import SweetAlert from "react-bootstrap-sweetalert";
import { UPDATE_ONE_PAYMENT_GATEWAY } from "../../graphql/mutation/UPDATE_ONE_PAYMENT_GATEWAY";
import ToastHelper from "../../helpers/ToastHelper";

function PaymentGatewayItem(props) {
  const { paymentGateway, refetch } = props;

  const [isActive, setIsActive] = React.useState(false);
  const [isToggleArchive, setIsToggleArchive] = React.useState(false);

  const [updateOnePaymentGateway] = useMutation(UPDATE_ONE_PAYMENT_GATEWAY);

  React.useEffect(() => {
    if (paymentGateway) {
      setIsActive(paymentGateway.node.isActive);
    }
  }, [paymentGateway]);

  return (
    <React.Fragment>
      <tr className="font-size-13 payment-item">
        <td className="relative">
          <EasyEdit
            value={paymentGateway.node.name}
            type="text"
            onSave={(value) => {
              updateOnePaymentGateway({
                variables: {
                  input: {
                    update: {
                      name: value,
                    },
                    id: paymentGateway.node.id,
                  },
                },
              })
                .catch((e) => {
                  ToastHelper.toggleToast({
                    toastType: "error",
                    message: e,
                    title: "",
                    onClick: function () { },
                  });
                })
                .then((val) => {
                  if (val) {
                    ToastHelper.toggleToast({
                      message: "Update Succesfully!",
                      title: "",
                      onClick: function () { },
                    });
                  }
                });
            }}
            saveButtonLabel={
              <i className="mdi mdi-check font-size-16 align-middle"></i>
            }
            cancelButtonLabel={
              <i className="mdi mdi-close font-size-16 align-middle"></i>
            }
            saveButtonStyle="easy-edit-button-save"
            cancelButtonStyle="easy-edit-button-cancel"
          />
        </td>
        <td className="relative">
          <EasyEdit
            value={paymentGateway.node.sequence.toString()}
            type="text"
            onSave={(value) => {
              updateOnePaymentGateway({
                variables: {
                  input: {
                    update: {
                      sequence: Number(value),
                    },
                    id: paymentGateway.node.id,
                  },
                },
              })
                .catch((e) => {
                  ToastHelper.toggleToast({
                    toastType: "error",
                    message: e,
                    title: "",
                    onClick: function () { },
                  });
                })
                .then((val) => {
                  if (val) {
                    ToastHelper.toggleToast({
                      message: "Update Succesfully!",
                      title: "",
                      onClick: function () { },
                    });
                  }
                });
            }}
            saveButtonLabel={
              <i className="mdi mdi-check font-size-16 align-middle"></i>
            }
            cancelButtonLabel={
              <i className="mdi mdi-close font-size-16 align-middle"></i>
            }
            saveButtonStyle="easy-edit-button-save"
            cancelButtonStyle="easy-edit-button-cancel"
          />
        </td>
        <td className="relative">
          <div>{paymentGateway.node.paymentMethodCode}</div>
        </td>
        <td className="relative">
          <div>{paymentGateway.node.paymentGatewayTransactionType}</div>
        </td>
        <td className="relative">
          <div>{paymentGateway.node.baseExchangeRate}</div>
        </td>
        <td className="relative">
          <div>{paymentGateway.node.depositExchangeRate}</div>
        </td>
        <td className="relative">
          <div>{paymentGateway.node.withdrawalExchangeRate}</div>
        </td>
        <td className="relative">
          <EasyEdit
            value={paymentGateway.node.depositMarkupRate}
            type="text"
            onSave={(value) => {
              updateOnePaymentGateway({
                variables: {
                  input: {
                    update: {
                      depositMarkupRate: Number(value),
                    },
                    id: paymentGateway.node.id,
                  },
                },
              })
                .catch((e) => {
                  ToastHelper.toggleToast({
                    toastType: "error",
                    message: e,
                    title: "",
                    onClick: function () { },
                  });
                })
                .then((val) => {
                  if (val) {
                    ToastHelper.toggleToast({
                      message: "Update Succesfully!",
                      title: "",
                      onClick: function () { },
                    });
                  }
                });
            }}
            saveButtonLabel={
              <i className="mdi mdi-check font-size-16 align-middle"></i>
            }
            cancelButtonLabel={
              <i className="mdi mdi-close font-size-16 align-middle"></i>
            }
            saveButtonStyle="easy-edit-button-save"
            cancelButtonStyle="easy-edit-button-cancel"
          />
        </td>
        <td className="relative">
          <EasyEdit
            value={paymentGateway.node.withdrawalMarkupRate}
            type="text"
            onSave={(value) => {
              updateOnePaymentGateway({
                variables: {
                  input: {
                    update: {
                      withdrawalMarkupRate: Number(value),
                    },
                    id: paymentGateway.node.id,
                  },
                },
              })
                .catch((e) => {
                  ToastHelper.toggleToast({
                    toastType: "error",
                    message: e,
                    title: "",
                    onClick: function () { },
                  });
                })
                .then((val) => {
                  if (val) {
                    ToastHelper.toggleToast({
                      message: "Update Succesfully!",
                      title: "",
                      onClick: function () { },
                    });
                  }
                });
            }}
            saveButtonLabel={
              <i className="mdi mdi-check font-size-16 align-middle"></i>
            }
            cancelButtonLabel={
              <i className="mdi mdi-close font-size-16 align-middle"></i>
            }
            saveButtonStyle="easy-edit-button-save"
            cancelButtonStyle="easy-edit-button-cancel"
          />
        </td>
        <td className="relative">
          <div>
            {paymentGateway.node.baseCurrency.code}/
            {paymentGateway.node.pairCurrency.code}
          </div>
        </td>
        <td className="relative">
          <div className="custom-control custom-switch mb-2" dir="ltr">
            <input
              type="checkbox"
              className="custom-control-input pointer"
              id="customSwitch1"
              checked={isActive}
            />
            <label
              className="custom-control-label pointer"
              htmlFor="customSwitch1"
              onClick={() => {
                let newVal = !isActive;
                setIsActive(newVal);
                updateOnePaymentGateway({
                  variables: {
                    input: {
                      update: {
                        isActive: newVal,
                      },
                      id: paymentGateway.node.id,
                    },
                  },
                })
                  .catch((e) => {
                    ToastHelper.toggleToast({
                      toastType: "error",
                      message: e,
                      title: "",
                      onClick: function () { },
                    });
                  })
                  .then((val) => {
                    if (val) {
                      ToastHelper.toggleToast({
                        message: "Update Succesfully!",
                        title: "",
                        onClick: function () { },
                      });
                    }
                  });
              }}
            ></label>
          </div>
        </td>
        <td className="relative">
          <button
            type="button"
            className="btn btn-outline-danger btn-sm"
            onClick={() => setIsToggleArchive(true)}
          >
            <i className="bx bx-archive font-size-16 align-middle"></i>
          </button>
        </td>
      </tr>
      {isToggleArchive && (
        <SweetAlert
          info
          showCancel
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="primary"
          title={"Alert"}
          onConfirm={() => {
            setIsToggleArchive(false);
            updateOnePaymentGateway({
              variables: {
                input: {
                  update: {
                    isArchived: true,
                  },
                  id: paymentGateway.node.id,
                },
              },
            })
              .catch((e) => {
                ToastHelper.toggleToast({
                  toastType: "error",
                  message: e,
                  title: "",
                  onClick: function () { },
                });
              })
              .then((val) => {
                if (val) {
                  ToastHelper.toggleToast({
                    message: "Archived Successfully!",
                    title: "",
                    onClick: function () { },
                  });
                  if (refetch) refetch();
                }
              });
          }}
          onCancel={() => setIsToggleArchive(false)}
        >
          {`Are you sure you want to ARCHIVE ${paymentGateway.node.name}?`}
        </SweetAlert>
      )}
    </React.Fragment>
  );
}

export default PaymentGatewayItem;
